import reducer from '../utils/reducer'
import { ACTION_NAMES } from '../utils/actionConstants'

const initialState = {
  
}

export default reducer(initialState, {
  [ACTION_NAMES.MAINTENANCE.REQUEST_MAINTENANCE_STATUS]: (state, payload) => {
      return {
        state
      }
    },
    [ACTION_NAMES.MAINTENANCE.RECEIVE_MAINTENANCE_STATUS]: (state, payload) => {
      return {
        ...payload,
        loading: false
      }
    }
  })
  